/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Personsbutoperativ4Inputs */

const de__field_personsbutoperativ4 = /** @type {(inputs: _Field_Personsbutoperativ4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Person BuT Operativ`)
};

/**

* @param {_Field_Personsbutoperativ4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_personsbutoperativ4 = /** @type {((inputs?: _Field_Personsbutoperativ4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Personsbutoperativ4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_personsbutoperativ4(inputs)
});
export { _field_personsbutoperativ4 as "_field_personsBUTOperativ" }